import React from 'react';
import  { useEffect } from 'react'
import {Container, Form,  Input,  } from 'semantic-ui-react';
import Box from '@mui/material/Box';
import { DataGrid  } from '@mui/x-data-grid';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import DateRangeIcon from '@mui/icons-material/DateRange';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Tooltip , Typography , IconButton } from '@mui/material';
import useGetRoutesExpress from '../../../hooks/getRoutesExpress';
import { MicNone } from '@mui/icons-material';
import useObtenerDatosdeCliente from '../../../hooks/obtenerDatosdeCliente';
import Moment from 'moment';


// const rows = [
  
//   { id: 1, vehicle: 'BICCI001', userRiders: 'Adrian Medina', dicpachts: 45, dicpachtsDate: '26/07/2022', dicpachtsHour: '9:00 am', createDate: '25/07/2022',},
//   { id: 2, vehicle: 'BICCI002', userRiders: 'Adrian Medina', dicpachts: 45, dicpachtsDate: '26/07/2022', dicpachtsHour: '9:00 am', createDate: '25/07/2022',},
//   { id: 3, vehicle: 'BICCI003', userRiders: 'Adrian Medina', dicpachts: 45, dicpachtsDate: '26/07/2022', dicpachtsHour: '9:00 am', createDate: '25/07/2022',},
//   { id: 4, vehicle: 'BICCI004', userRiders: 'Adrian Medina', dicpachts: 45, dicpachtsDate: '26/07/2022', dicpachtsHour: '9:00 am', createDate: '25/07/2022',},
//   { id: 5, vehicle: 'BICCI001', userRiders: 'Adrian Medina', dicpachts: 45, dicpachtsDate: '26/07/2022', dicpachtsHour: '9:00 am', createDate: '25/07/2022',},
//   { id: 6, vehicle: 'BICCI001', userRiders: 'Adrian Medina', dicpachts: 45, dicpachtsDate: '26/07/2022', dicpachtsHour: '9:00 am', createDate: '25/07/2022',},
// ];

const Rutas = (props) => {
  const usuarioStorage = JSON.parse(localStorage.getItem('usuario'))
  const usuarioLocal = usuarioStorage.uid;
  const LocalRol = usuarioStorage.roll;

  //let companyId = null
  const[companyId,setCompanyId] = React.useState(null);
  const[userRoll,setUserRoll] = React.useState(null);
  const[routeDate,setRouteDate] = React.useState('');
  const[userRider, setUserRiderr] = React.useState('');
  const[userVehicle, setUserVehicle] = React.useState('');
  const[routeRows, setRouteRows] = React.useState(null);
  const {userdata  } = useObtenerDatosdeCliente(usuarioLocal)

  const { compayRoutesExpress, bicciRoutesExpress, loadRoutesExpress, errorRoutesExpress } = useGetRoutesExpress(companyId,userRoll,routeDate,userRider,userVehicle)
  const columns = [
    {
      field: 'vehicle',
      headerName: 'Veículo',
      width: 100,
      editable: true,
    },
    { field: 'id', headerName: 'ID', width: 100 },
    {
      field: 'userRiders',
      headerName: 'Usuario Rider',
      width: 100,
      editable: true,
    },
    {
      field: 'dicpachts',
      headerName: 'Despachos',
      description: 'This column has a value getter and is not sortable.',
      sortable: false,
      width: 50,
      // valueGetter: (params) =>
      //   `${params.row.firstName || ''} ${params.row.lastName || ''}`,
    }, 
    {
      field: 'dicpachtsDate',
      headerName: 'Fecha de despacho',
      width: 120,
      editable: true,
    },
    {
      field: 'dicpachtsHour',
      headerName: 'Hora de inicio',
      width: 150,
      editable: true,
    },
    {
      field: 'createDate',
      headerName: 'Fecha de creacion',
      width: 150,
      editable: true,
    },
    {
      field: 'actions',
      headerName: 'Acciones',
      width: 250,
      renderCell: (routeRows) => {   
        // // console.log(arrayelement)
        // var id = arrayelement.row.id
        return (<>
            <button
              className='btn-bicci-small btn-globalhover-calipso'
              variant="contained"
              color="primary"
              size="small"
              id={routeRows.id}
              style={{ marginLeft: 5 }}
             onClick={handleGoProps}
            >
              Editar Ruta
            </button>
            <button
            className='btn-bicci-small btn-globalhover-calipso'
            variant="contained"
            color="primary"
            size="small"
            id={routeRows.id}
            style={{ marginLeft: 5 }}
            onClick={handleGoDispatches}
            >
            Gestion
            </button>
            </>
           )
          },
    },
  ];
// // console.log(props)
// // console.log(compayRoutesExpress)
// // console.log(bicciRoutesExpress)

useEffect(()=>{
  if(userdata){
    setCompanyId(userdata.userCompanyID) 
    setUserRoll(LocalRol)
  }
},[userdata])

useEffect(()=>{
  getBicciRoutesExpressData()
  // console.log(bicciRoutesExpress)
},[bicciRoutesExpress])

useEffect(()=>{
// console.log(compayRoutesExpress)
},[compayRoutesExpress])

const getBicciRoutesExpressData = () => {
if(bicciRoutesExpress){
  var rows = []
  for (let i = 0; i < bicciRoutesExpress.length; i++) {
    rows.push ( { id: bicciRoutesExpress[i].id, vehicle: bicciRoutesExpress[i].vehicleID, userRiders: bicciRoutesExpress[i].driverName, dicpachts: bicciRoutesExpress[i].setRoutePoints, dicpachtsDate: Moment(bicciRoutesExpress[i].dateDeliveryText).format('DD MMMM YYYY, h:mm:ss a') , dicpachtsHour: bicciRoutesExpress[i].startTimeDelivery + ' hr', createDate:Moment( bicciRoutesExpress[i].createDate).format('DD MMMM YYYY, h:mm:ss a')});
  }
  setRouteRows(rows)
}else{
  // console.log('Sin data')
}

}

const handleGoProps =(e)=>{
  e.preventDefault()
  // console.log(e.target.id)
  props.history.push(`/dashboard/route/${e.target.id}/edit`)
}
const handleGoDispatches =(e)=>{
  e.preventDefault()
  // console.log(e.target.id)
  props.history.push(`/dashboard/route/${e.target.id}/dispatches`)
}

const filtrarRutas =(e)=>{
  e.preventDefault()
  // console.log('Buscar')
}

function checkboxSelection (e){
  // console.log(e.targat)
} 

function handleClickNew (e){
  e.preventDefault()
  props.history.push(`/dashboard/routes/new`)
}

function handleClick (){
  // console.log('handleClick')
}

  return (  
    <div>
 
    <Container  className='containerroutes' >
      <div className='containerroutesdiv'>
          <Box
            sx={{
              width: 300,
              height: 50,
              backgroundColor: '#e0e0e0',
              textAlign:'center',
              p:1,
              '&:hover': {
                backgroundColor: '#e0f7fa',
                opacity: [0.9, 0.8, 0.7],
              },
            }}
            >
            <h2> Filtros</h2>
           </Box>
       <Box
            sx={{
              width: 300,
              height: '100%',
              backgroundColor: '#eeeeee',
              p:1,
              '&:hover': {
                backgroundColor: '#eeeeee',
                opacity: [0.9, 0.8, 0.7],
              },
            }}>

              <Box
              sx={{
              textAlign: 'center',
              width: '100%',
              height: '100%',
              backgroundColor: '#eeeeee',
              p:2,}}>
                <form onSubmit={filtrarRutas}>
                <Form.Group widths='equal'>
                <Form.Field 
                    control={Input}
                    type = "date"
                    label='Filtro de Fecha'
                    iconPosition='left'
                   
                    onChange={e => setRouteDate(e.target.value)}
                    value ={routeDate}
                    />
                  </Form.Group>
                  <hr></hr>
                  <Form.Group widths='equal'>
                <Form.Field 
                    control={Input}
                    type = "text"
                    label='Usuario Rider'
                    placeholder='ID Rider'
                    iconPosition='left'
                    icon = 'user' 
                    onChange={e => setUserRiderr(e.target.value)}
                    value ={userRider}
                    />
                  </Form.Group>
                  <hr></hr>
                  <Form.Group widths='equal'>
                <Form.Field 
                    control={Input}
                    type = "text"
                    label='Vehículo'
                    placeholder='Patente/Placa'
                    iconPosition='left'
                    icon = 'truck' 
                    onChange={e => setUserVehicle(e.target.value)}
                    value ={userVehicle}
                    />
                  </Form.Group>
                  <hr></hr>
                  {/* <button>Buscar</button> */}
                </form>
              </Box>
            
            </Box>

    </div>
    <div  className='containerroutesdivleft'>
    <Box
          className='containerroutesdivbox'
          sx={{
            width: '100%',
            height: 50,
            backgroundColor: '#fafafa',
           
            p:1,
            
            }}
            >
              <Box  sx={{ display: 'flex', alignItems: 'center', textAlign: 'center', 
            justifyContent: 'space-between', }}>
              <Typography sx={{ minWidth: 100 }}>Últimas Rutas  </Typography>
              <Tooltip title="Account settings">
                <IconButton
                  onClick={handleClick}
                  size="small"
                  sx={{ ml: 2, color:"#4a148c",
                        border: "none",
                       }}
                  
                >
                <DateRangeIcon sx={{ width: 32, height: 32 }}></DateRangeIcon>Reasignar ruta
                </IconButton>
             </Tooltip>
            
             <Tooltip title="Reasignar ruta">
                <IconButton
                  onClick={handleClick}
                  size="small"
                  sx={{ 
                    ml: 2, 
                    color:"#4a148c",
                    '&:focus': {
                      outline: 'none!important',      
                    }
                  
                  }}
                >
                <FileUploadIcon sx={{ width: 32, height: 32 }}></FileUploadIcon>Importar
                </IconButton>
             </Tooltip>

             <Tooltip title="Reasignar ruta">
                <IconButton
                  onClick={handleClickNew}
                  size="small"
                  sx={{ ml: 2, color:"#4a148c" }}
                >
                <AddCircleIcon sx={{ width: 32, height: 32 }}></AddCircleIcon>Nueva Ruta
                </IconButton>
             </Tooltip>


              </Box>
           </Box>
          
      <Box sx={{ 
            height: 400, 
            width: '100%',
            backgroundColor: '#fafafa',
         }}>
          {
            routeRows?(<DataGrid
              sx={{   
              display: 'flex',  
              justifyContent: 'space-between',
              width: '100%',}}
                rows={routeRows}
                columns={columns}
                pageSize={5}
                rowsPerPageOptions={[10]}
                disableSelectionOnClick
                onClick ={checkboxSelection}
              />):(<></>)
          }

      </Box>

    </div>
    </Container> 
    </div>
    ); 
  };

export default Rutas;

